@if (activeQuestion()) {
  <div class="conditional__container">
    <div class="conditional__title">
      <span class="conditional__main-title fs__xl fw__500">Conditional Logic</span>
      <span class="conditional__sub-title fs__md">Specify below when this question will be visible:</span>
    </div>
    <div class="conditional__content">
      @if (previousQuestions$().length > 0) {
        <div class="conditional__condition-card">
          <div class="eiq-id-badge primary">
            <fa-icon [icon]="faCodeBranch"></fa-icon>
            @if (activeOption()) {
              <span>{{ activeQuestion().value.code }} {{ activeOption() ? '- ' + activeOption().get('id').value : '' }} is shown only if</span>
            } @else if (activeCard) {
              <span>{{ activeQuestion().value.code }} {{ activeCard() ? '- ' + activeCard().get('id').value : '' }} is shown only if</span>
            } @else {
              <span>{{ activeQuestion().value.code }} is shown only if</span>
            }
          </div>

          @if (activeOption()) {
            <empathy-conditions-block
              [conditions]="activeOption().get('visibleWhen').value"
              [isEditing]="isEditing$()"
              [previousQuestions]="previousQuestions$()"
              (save)="onSave($event)"
              (cancel)="isEditing$.set(false)"
              (addMore)="isEditing$.set(true)"
              (remove)="onRemoveCondition($event)"
            ></empathy-conditions-block>
          } @else if (activeCard()) {
            <empathy-conditions-block
              [conditions]="activeCard().get('visibleWhen').value"
              [isEditing]="isEditing$()"
              [previousQuestions]="previousQuestions$()"
              (save)="onSave($event)"
              (cancel)="isEditing$.set(false)"
              (addMore)="isEditing$.set(true)"
              (remove)="onRemoveCondition($event)"
            ></empathy-conditions-block>
          } @else {
            <empathy-conditions-block
              [conditions]="activeQuestion().get('visibleWhen').value"
              [isEditing]="isEditing$()"
              [previousQuestions]="previousQuestions$()"
              (save)="onSave($event)"
              (cancel)="isEditing$.set(false)"
              (addMore)="isEditing$.set(true)"
              (remove)="onRemoveCondition($event)"
            ></empathy-conditions-block>
          }
        </div>
      } @else {
        <p class="conditional__no-condition-possible fs__md fw__600">There are no previous questions to set a condition.</p>
      }
    </div>
  </div>
} @else if (activeHiddenQuestion()) {
  <div class="conditional__container">
    <div class="conditional__title">
      <span class="conditional__main-title fs__xl fw__500">Conditional Hidden Logic</span>
      <span class="conditional__sub-title fs__md">Specify below when this question will be selectable:</span>
    </div>
    <div class="conditional__content">
      @if (this.surveyEditorService.surveyEditor$().questions.length > 0) {
        @if (activeHiddenOption()) {
          <div class="conditional__condition-card">
            <div class="eiq-id-badge primary">
              <fa-icon [icon]="faCodeBranch"></fa-icon>
              <span>{{ activeHiddenQuestion().value.code }} {{ activeHiddenOption() ? '- ' + activeHiddenOption().get('id').value : '' }} is selected if</span>
            </div>

            <empathy-conditions-block
              [conditions]="activeHiddenOption().get('selectedWhen').value"
              [isEditing]="isEditing$()"
              [previousQuestions]="previousQuestions$()"
              (save)="onSave($event)"
              (cancel)="isEditing$.set(false)"
              (addMore)="isEditing$.set(true)"
              (remove)="onRemoveCondition($event)"
            ></empathy-conditions-block>
          </div>
        } @else {
          <p class="conditional__no-condition-possible fs__md fw__600">
            Select an option from {{ activeHiddenQuestion().value.id }} to start adding selectable conditions
          </p>
        }
      }
    </div>
  </div>
}
